import { useQuery } from '@hooks/reactQuery';

import { getPresets } from '@api/kpi';

import { extractQueryParams } from '@utils/common';

import { TPresetTypeDTO, TPresetTypeProps } from '@interfaces/kpi/dto/kpiDTO';

import { EUserRoles, EVendorsValues } from '@enums/common';
import { EPresetsGroupNames } from '@enums/kpi-common';

import { refetchOptions } from '@constants/common';
import { PRESET_OPTIONS } from '@constants/queryKeys';

interface IUseQueryPresets {
	isKpiView: boolean;
	vendor?: string;
}

export const useQueryPresets = ({ isKpiView, vendor }: IUseQueryPresets) => {
	const isOranVendor = vendor == EVendorsValues.oran;

	const {
		data: presets,
		isLoading: isLoadingPreset,
	} = useQuery<TPresetTypeDTO[], TPresetTypeProps[]>({
		queryKey: [PRESET_OPTIONS, { vendor }],
		queryFn: extractQueryParams(getPresets),
		select: (presets: TPresetTypeDTO[]) => presets.map(preset => {
			return ({
				...preset,
				label: preset.name,
				value: preset.id,
				granularity: preset?.granularity?.name,
				subText: preset?.dateRangeLabel,
				...(isOranVendor && {
						groupLabel: preset?.isShared
							? EPresetsGroupNames.shared
							: EPresetsGroupNames.personal,
					}
				),
			});
		}),
		allowedRoles: [
			EUserRoles.networkOperatorKpiViewer,
			EUserRoles.networkOperatorKpiUpdater,
		],
		enabled: [isKpiView, vendor],
		...refetchOptions,
	});

	return {
		presets,
		isLoadingPreset,
	};
};
